import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'
const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/application',
        name: 'application',
		subheader: languages.application.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "01",
            icon: "laptop",
        },
        component: PageAll,
		children: [
			{
				path: '/application/list',
				name: 'application-list',
				component: resolve => require(['@/pages/application/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.application.title1,
					permCode: "0101",
				},
			}
		]
    },
]
  